import AdminUpgradeInfo from './AdminUpgradeInfo';

export default AdminUpgradeInfo;
